// StationPanelLine – kompaktní řádek bez fotky: gh_id, název, typ, souřadnice, výška, obs_type; použit ve virtualizované tabulce v StationSelectLayout
import { Button, Chip } from '@heroui/react'

function getDistinctObsTypes(station) {
  if (!station.observation) return []
  return [...new Set(station.observation.map(o => o.obs_type))]
}

// Ultra-compact row without photo — used in virtualized table
export function StationPanelLine({ station, onSelect, isSelected }) {
  const obsTypes = getDistinctObsTypes(station)

  return (
    <div
      className={`flex items-center gap-2 px-3 py-1.5 border-b border-gray-100 text-sm hover:bg-blue-50 transition-colors ${isSelected ? 'bg-blue-50 border-l-2 border-l-blue-500' : ''}`}
    >
      {/* GH_ID */}
      <span className="font-mono text-xs text-gray-500 w-[90px] shrink-0">{station.gh_id}</span>

      {/* Name */}
      <span className="flex-1 min-w-0 truncate font-medium">{station.full_name || station.name}</span>

      {/* Period */}
      <span className="text-xs text-gray-500 w-[80px] text-center shrink-0">
        {station.begin_date ? `${station.begin_date.split('-')[0]} – ${(station.end_date.split('-')[0])=='3999'?'dosud':station.end_date.split('-')[0]}` : '—'}
      </span>

      {/* Type */}
      <span className="text-xs bg-gray-100 px-1.5 py-0.5 rounded text-gray-600 w-[50px] text-center shrink-0">
        {station.station_type}
      </span>

      {/* Coords */}
      <span className="text-xs text-gray-400 w-[170px] shrink-0 hidden md:block">
        {station.latitude?.toFixed(4)}° {station.longitude?.toFixed(4)}°
      </span>

      {/* Elevation */}
      <span className="text-xs text-gray-500 w-[60px] text-right shrink-0">
        {station.elevation != null ? `${station.elevation} m` : '—'}
      </span>

      {/* Obs types */}
      <div className="flex flex-wrap gap-0.5 w-[200px] shrink-0 hidden lg:flex">
        {obsTypes.slice(0, 5).map(t => (
          <Chip key={t} size="sm" variant="flat" className="text-xs h-4 px-1">{t}</Chip>
        ))}
        {obsTypes.length > 5 && (
          <span className="text-xs text-gray-400">+{obsTypes.length - 5}</span>
        )}
      </div>

      {/* Select button */}
      <Button
        size="sm"
        variant={isSelected ? 'primary' : 'secondary'}
        className="shrink-0 h-6 px-2 text-xs"
        onPress={() => onSelect && onSelect(station)}
      >
        Vybrat
      </Button>
    </div>
  )
}
